/* ==========================================================================
   Palmora — JS chung cho các trang phụ (nạp ở layout/theme.liquid, defer)
   - Ô sắp xếp trang danh mục: đổi lựa chọn thì tải lại với ?sort_by=...
   - Giỏ hàng: số lượng nhập tay thay đổi thì làm nổi bật nút "Update".
   Header/drawer/thanh thông báo: assets/pm-chrome.js. Trang sản phẩm: assets/pm-product.js.
   ========================================================================== */
(function () {
  'use strict';

  /* Sắp xếp danh mục */
  document.addEventListener('change', function (event) {
    var select = event.target && event.target.closest ? event.target.closest('[data-sort-select]') : null;
    if (!select) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* Giỏ hàng: đổi số lượng => nút Update chuyển sang kiểu nút chính để người dùng thấy cần bấm */
  document.addEventListener('input', function (event) {
    var input = event.target && event.target.closest ? event.target.closest('[data-pm-cart-qty]') : null;
    if (!input || !input.form) return;
    var update = input.form.querySelector('button[name="update"]');
    if (update) update.classList.remove('pm-btn--outline');
  });
})();
